export var createAction = function(type) {
    return function() {
        var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return {
            type: type,
            payload: payload
        };
    };
};
export default createAction;

//# sourceMappingURL=createAction.js.map